const baseRoute = import.meta.env.VITE_AUTH_URL;

export const publicRoutes = {
  authorizePublicUser: `${baseRoute}/share`,
} as const;
